var parent = require('../../es/instance/find-index');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/find-index.js
// module id = 1112
// module chunks = 0